<template>
    <h4 class="text-center">Assessment Complete</h4>
      <p class="card-text">Thanks for taking the assessment & good luck!</p>
      <form @submit.prevent="submitForm">
        Thanks
        <div class="text-center m-3">
          <button type="submit" class="btn btn-primary submit-button">Exit</button>
        </div>
      </form>  
</template>
<script>
import { deleteAllCookies } from '@/utils/cookies/cookieUtils';
import router from '@/router';
export default {
  name: 'AssessmentFinish',
  data() {
    return {
    }
  },
  methods: {
    submitForm() {
        deleteAllCookies();
        router.push('/');
    }
  }
}
</script>
<style scoped>
.submit-button {
  width: 300px;
  padding: 10px;
  background-color: #382d61;
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #72018f;
}
</style>